import React from 'react';
import Form from 'antd/lib/form';
import 'antd/lib/form/style/index.css';
import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';
var ListTeamFilterString = function (props) { return (React.createElement(Form.Item, { label: React.createElement("strong", null, "Search by name"), colon: false },
    React.createElement(Input, { size: 'large', onChange: function (e) {
            props.setFilters({ filterString: e.target.value });
        } }))); };
export default ListTeamFilterString;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListTeamPage/ListTeamFilterString.tsx
// module id = 1092
// module chunks = 0